import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Network/IP_Configuration/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import IPConfigTable from 'components/Web_User_Interface/1440p_Series/Network/IP_Configuration/ipConfigTable';
import IPConfigTableIPv6 from 'components/Web_User_Interface/1440p_Series/Network/IP_Configuration/ipConfigTableIPv6';
import CertCards from 'components/Web_User_Interface/1440p_Series/Network/IP_Configuration/CertCards';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Netzwerk Menü // IP Konfiguration",
  "path": "/Web_User_Interface/1440p_Serie/Netzwerk/IP_Konfiguration/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Ändern Sie die IP-Adresse, das Gateway und den DNS-Server der Kamera - alle diese Einstellungen werden normalerweise vom Installationsassistenten eingerichtet und müssen nicht geändert werden. Der http-Port der Kamera muss möglicherweise geändert werden, um über das Internet auf die WebUI der Kamera zuzugreifen.",
  "image": "./WebUI_1440p_SearchThumb_Network_IP_Configuration.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='Netzwerk Menü // IP Konfiguration' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Ändern Sie die IP-Adresse, das Gateway und den DNS-Server der Kamera - alle diese Einstellungen werden normalerweise vom Installationsassistenten eingerichtet und müssen nicht geändert werden. Der http-Port der Kamera muss möglicherweise geändert werden, um über das Internet auf die WebUI der Kamera zuzugreifen.' image='/images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Network/IP_Configuration/' locationFR='/fr/Web_User_Interface/1440p_Series/Network/IP_Configuration/' crumbLabel="IP Configuration" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "netzwerk-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#netzwerk-men%C3%BC",
        "aria-label": "netzwerk menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Netzwerk Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/14aef86f935296b6fe638809dbe49b09/d9199/1440p_WebUI_Network_IP_Configuration.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.60869565217391%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACMElEQVQoz12SWW/TQBRG+yuoUNu0b20SJ0WVmsXxnqVZ7Dge24lJUgES4oUHWolCmxYJfgYvSMRFLH/yIE8apfBwdK/GM0ffHc+WopQo5I8on1QZflgyuP5N7+oH3fcrWpf32BcpzgP2u5TWZYp3/ZPk7h7DctjefsLO7g4HBwdsFYtF8keHlE8qJDff5KbxYsnkNiW5SxnfpkSLlOhmRby4J14sOf/8i+nHr6gNk6PDPEqxTKGgsFUoFMgoKUXcbpN4NGCeCOYTIfvA7RAOu4wGHdlHfo+R28HvNfG6LQzdwTRa2FabWrXxSFgqEUYx09lcMpufM0meE4iQQESIcEMYhoTzNwRhQtNuYRq2FFdO66uR18IoikiSZHUgDBFCEASB7F3Xpd1uSyzLwm735TffdXBsG9NoUqk8EiqKIg9mwrVoTbbe7/elyDRNVFVFrdcJhcd04mAZphRWq/XNyGvhZDKRSR9Ls/Vev49t2xiGgarWaTQ0ROAhXAvLsGg7NvXagzCfz0uhEKuEGZl0IxQMBn1sy0LXdTRNQ9V0plHAzO9gGboUViu1f+/Q932Z7P+RM0aBYOgH+EOfkefhuR4vxzGfXgjaTZum09r85SxhJsxEcRzLdFmN4zFxJIjnr5ndfmfy5Q8Xr65Iey5LL+Tt0Mdr1jg9Oea4/IxiUXl42Pm8TJmNk116VhuNhhxNk1VHtztozhmmbtFRG5xpGvVKlae7e+zt5cjlcuzv7/MX+2mZkgwYbg8AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/14aef86f935296b6fe638809dbe49b09/e4706/1440p_WebUI_Network_IP_Configuration.avif 230w", "/de/static/14aef86f935296b6fe638809dbe49b09/d1af7/1440p_WebUI_Network_IP_Configuration.avif 460w", "/de/static/14aef86f935296b6fe638809dbe49b09/7f308/1440p_WebUI_Network_IP_Configuration.avif 920w", "/de/static/14aef86f935296b6fe638809dbe49b09/542bc/1440p_WebUI_Network_IP_Configuration.avif 960w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/14aef86f935296b6fe638809dbe49b09/a0b58/1440p_WebUI_Network_IP_Configuration.webp 230w", "/de/static/14aef86f935296b6fe638809dbe49b09/bc10c/1440p_WebUI_Network_IP_Configuration.webp 460w", "/de/static/14aef86f935296b6fe638809dbe49b09/966d8/1440p_WebUI_Network_IP_Configuration.webp 920w", "/de/static/14aef86f935296b6fe638809dbe49b09/e46b2/1440p_WebUI_Network_IP_Configuration.webp 960w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/14aef86f935296b6fe638809dbe49b09/81c8e/1440p_WebUI_Network_IP_Configuration.png 230w", "/de/static/14aef86f935296b6fe638809dbe49b09/08a84/1440p_WebUI_Network_IP_Configuration.png 460w", "/de/static/14aef86f935296b6fe638809dbe49b09/c0255/1440p_WebUI_Network_IP_Configuration.png 920w", "/de/static/14aef86f935296b6fe638809dbe49b09/d9199/1440p_WebUI_Network_IP_Configuration.png 960w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/14aef86f935296b6fe638809dbe49b09/c0255/1440p_WebUI_Network_IP_Configuration.png",
              "alt": "Web User Interface - 1440p Series - Network IP Configuration",
              "title": "Web User Interface - 1440p Series - Network IP Configuration",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h3 {...{
      "id": "netzwerk-konfiguration-einstellen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#netzwerk-konfiguration-einstellen",
        "aria-label": "netzwerk konfiguration einstellen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Netzwerk Konfiguration einstellen`}</h3>
    <p>{`Stellen Sie ein, ob Ihre Kamera automatisch eine IP Adresse von Ihrem Router beziehen soll (DHCP), oder ob Sie ihr eine statische IP Adresse vergeben möchten. Wenn Sie den Erstinstallations-Wizard durchlaufen haben, wird Ihre Kamera bereits eine statische IP haben - und dies ist auch die Einstellung, die wir empfehlen um Probleme beim Fernzugriff auf die Kamera vorzubeugen.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <IPConfigTable mdxType="IPConfigTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/c7547862e1624ce5e4cebfd46e6dcb87/d9199/1440p_WebUI_Network_IP_Configuration_IPv6.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.60869565217391%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACM0lEQVQoz1WS204aURSGfYo2jYre6cCAjYkchGFmOAxVhDkPw8FqrYjijaamSrVJn6KHmzYRjOlTfs1soejFl3/Wmp0//1p7L8hykri0TmozQ/PzPfXrv7y7eqB2NRFauZygX4wpTYm+K5djGjePhHcTilqJ169fsbi0yOrqKguJRAJpfY3UZppw9Jvw7oHW7ZjwdkL7bkLwZYw3GuNP1Rvd44/u2f/2SOf6F9t5lfU1CTmRIh6XWYjH40TIcoLGTgV7z8CqG1h7BuZuVRDV5m4Fu27gNGpCzbpBY8egqJRQixV0rUo2k58bJlMpTMvGdlxczxd4fsD++wMOPxzR7e3juB5+0BL/HMfBshwqehW1qAvj9FbuaWRhmEyKQ61Wa3rYEup5Hq7rCrVtW/Qt08Ruf8QJ2ph1nZIepSyTTj8zlGVZGPR6PUHg+/jPiAwj7XQ6hGGIF3QIApd2oKGpmjDMZHLzkSPjbrfL+fk5w+GQs7MzTk9PBScnJxwfH9Pv9xkMBk+9fp+w5WDVVXRVo1rSyWWnhpIk/U8YBIFIMtOoN8ONmI4f7bEXuHSaVTRVEYaZdPblDpvN5nxPU6LaflbP2DNNDgOfrwcO1bJOuVSZ33KUcHYp/ovdBfiei985ovXpB+7NH4a9C34au3zfsRg0TJrlLFubG2yk3pJIyNOHLUkipaIoqKqKUlDI5/Pk84UnLSgUNIOCXkMtaBi5bWrbBXLpNG+WlllejhGLxVhZWeEfs6igK1xXtcsAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/c7547862e1624ce5e4cebfd46e6dcb87/e4706/1440p_WebUI_Network_IP_Configuration_IPv6.avif 230w", "/de/static/c7547862e1624ce5e4cebfd46e6dcb87/d1af7/1440p_WebUI_Network_IP_Configuration_IPv6.avif 460w", "/de/static/c7547862e1624ce5e4cebfd46e6dcb87/7f308/1440p_WebUI_Network_IP_Configuration_IPv6.avif 920w", "/de/static/c7547862e1624ce5e4cebfd46e6dcb87/542bc/1440p_WebUI_Network_IP_Configuration_IPv6.avif 960w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/c7547862e1624ce5e4cebfd46e6dcb87/a0b58/1440p_WebUI_Network_IP_Configuration_IPv6.webp 230w", "/de/static/c7547862e1624ce5e4cebfd46e6dcb87/bc10c/1440p_WebUI_Network_IP_Configuration_IPv6.webp 460w", "/de/static/c7547862e1624ce5e4cebfd46e6dcb87/966d8/1440p_WebUI_Network_IP_Configuration_IPv6.webp 920w", "/de/static/c7547862e1624ce5e4cebfd46e6dcb87/e46b2/1440p_WebUI_Network_IP_Configuration_IPv6.webp 960w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/c7547862e1624ce5e4cebfd46e6dcb87/81c8e/1440p_WebUI_Network_IP_Configuration_IPv6.png 230w", "/de/static/c7547862e1624ce5e4cebfd46e6dcb87/08a84/1440p_WebUI_Network_IP_Configuration_IPv6.png 460w", "/de/static/c7547862e1624ce5e4cebfd46e6dcb87/c0255/1440p_WebUI_Network_IP_Configuration_IPv6.png 920w", "/de/static/c7547862e1624ce5e4cebfd46e6dcb87/d9199/1440p_WebUI_Network_IP_Configuration_IPv6.png 960w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/c7547862e1624ce5e4cebfd46e6dcb87/c0255/1440p_WebUI_Network_IP_Configuration_IPv6.png",
              "alt": "Web User Interface - 1440p Series - Network IP Configuration",
              "title": "Web User Interface - 1440p Series - Network IP Configuration",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <IPConfigTableIPv6 mdxType="IPConfigTableIPv6" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "ipv6-port-weiterleitung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#ipv6-port-weiterleitung",
        "aria-label": "ipv6 port weiterleitung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IPv6 Port Weiterleitung`}</h3>
    <ul>
      <li parentName="ul">{`siehe auch:`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/Schnell_Installation/Internet_Protocol_IPv6/"
            }}>{`Was ist IPv6 und wie funktioniert SLAAC?`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/Frequently_Asked_Question/WQHD_IPv6_Portforwarding/"
            }}>{`Anleitung zur IPv6 Portfreischaltung in einer AVM Fritzbox`}</a></li>
        </ul>
      </li>
    </ul>
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/5dc491c59b45a57c11276eec6d8a30ac/09e48/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "63.91304347826087%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACY0lEQVQ4y3WSy29OQRjGD9GqS1D6nTMzZ+bcz5yvbb5WioVqEJdqkSaqNiKiLKhb4hYiro24dYXEQiQSiy6s2VlY2PirfjLn+4iiiyfv5M3M8z7vPI+36fgHXl46yM3ZCdZNf2DDmU+MPP7B6Px3ds1/Y/u9r1TXvzB69zON2UW6Zt7TPf2WVVOvWHl4Ae/AE7rHH7Lx6Dwr9t3H2zT5lHMn9zB9YpwNk8/YPL2AnVukdWWRocsfGT7/jvz0G1pnX9M49pw1E49YO36Pnv13WL33Bl1jV+nZNcf63RfpHr2Al9smohyi11iC0BAEPnLsFGrmBXLqAbLaRpykyCgjSnPiLEeEGl+GBB24c0O0q1daS5YlSCnwhcQXgji3xEWT1PaT5jnaGISUSBUilCKQcll4WVHgSJU2+EIhVEhoDHGSYKIIE8VESYo2EX1BZ6hUy8JL0pQsz2sFgRAIqXA9ay2lrSg61Q12q7uBjjSQ6r/wgsnb6CO36D1wjd5Dd9gyMkUYxZhiANlZT9RQyDCsH7UJf0EtGeCFgzspt+3B1T67Az/pR5gUmZQEOqkhoozApPhSd/5Z/YGlpF6oBGWeYrQk8Pvw/QZRXpFUg6TVIFmzhckrbGsrZbNJqBVCBkglEEr8qzBOM9K8QEcxQed/nCFlWRJqXbseRZrhlqVZpcSxwGgfoxuEOqhV/lq9JsyLsjbFOdteR2LipI6LM8A569weGLBUzRJrc4yRKOWj/qewTVh0YtMmdORRHZv49+Uky2qn3SD3JndnF3L1N2FZkmbZ73y5plMmQ70kIqIO9b/4W+FPB5p4jcvpVjkAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/5dc491c59b45a57c11276eec6d8a30ac/e4706/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.avif 230w", "/de/static/5dc491c59b45a57c11276eec6d8a30ac/d1af7/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.avif 460w", "/de/static/5dc491c59b45a57c11276eec6d8a30ac/7f308/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.avif 920w", "/de/static/5dc491c59b45a57c11276eec6d8a30ac/5578a/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.avif 974w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/5dc491c59b45a57c11276eec6d8a30ac/a0b58/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.webp 230w", "/de/static/5dc491c59b45a57c11276eec6d8a30ac/bc10c/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.webp 460w", "/de/static/5dc491c59b45a57c11276eec6d8a30ac/966d8/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.webp 920w", "/de/static/5dc491c59b45a57c11276eec6d8a30ac/7efa9/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.webp 974w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/5dc491c59b45a57c11276eec6d8a30ac/81c8e/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.png 230w", "/de/static/5dc491c59b45a57c11276eec6d8a30ac/08a84/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.png 460w", "/de/static/5dc491c59b45a57c11276eec6d8a30ac/c0255/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.png 920w", "/de/static/5dc491c59b45a57c11276eec6d8a30ac/09e48/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.png 974w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/5dc491c59b45a57c11276eec6d8a30ac/c0255/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_01.png",
              "alt": "Web User Interface - 1440p Series - Network IP Configuration",
              "title": "Web User Interface - 1440p Series - Network IP Configuration",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Die `}<strong parentName="p">{`Globale Adresse`}</strong>{` ist die, die im Router für die Ports freischalten werden muss, um einen Fernzugriff zu ermöglichen. Diese Adresse wird von Ihrer Kamera bei Ihrer DDNS hinterlegt und man kann darüber entsprechend von extern auf die Kamera zugreifen sobald der HTTP oder HTTPS Port im Router durchgeleitet wurde.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/9c4b20ab8f0730e587db414ecd8cd355/ae77d/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.95652173913044%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACEUlEQVQ4y1WT2XajMBBEHYMWwCC8sArE6oUkc+Zh/v/bak63wXEe6kioobhdDbv9ZUZyqeGKCOLUw8tmRO03YvcHiftCVD8Q2zt0cYV3HuGdB3inHvtjh/3R4SNt8WEsvLTB3ljsgjCEDg/wdQShNKSSUGkBce7hHS7wpYQnFHwhIaSCz5Iv0ZlUCmLVTmmNMAwRBJoLXJQScRLDuQptW6Eoz8jzI4ri9FJOa3nC6Wz4fgIh7YTwobWE1gpS+JBSsKlJDW7LgsfngmmeYNsGlbWsunmKzrIiZ0oyZUJxOEGZHDK5wI8ziMhAMmGCZrrjer+j7XoUFZm0sK1DZRsWXV/y4tWZZMP4An0sodMSwhQQUQqlFZI0ZZquH1DWljVME8Z5RuMcmz1fVLERRceGSkkEWkFTBmvLVDTpEZVt+cHNkOmaBnXreG9dh6wo1gxXQh0EoElLpTmDrRAbg5oIhwG2JeMG4zSjG0b0w8ikRFxU9YuQtNOBZkOtf6b8JDQYvv7hvnxyjmTk+gGN6550reM9ZcgDWfUiJJN3dBrKdfnGY1lwfzwwX29ou46JNlEM5yx7mcntO9wC3Q7pOjEGdrhyW8M4wfX902jN88cw/z1lapVbDoJfLdOUS9usA3muNIRufqDpR7jbJ4blL7KygnrPcNu8U5I5/SkmTVlEGx0OiA4xojhBFK9rYhBGEd49/gONFDfUURHlOwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/9c4b20ab8f0730e587db414ecd8cd355/e4706/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.avif 230w", "/de/static/9c4b20ab8f0730e587db414ecd8cd355/d1af7/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.avif 460w", "/de/static/9c4b20ab8f0730e587db414ecd8cd355/7f308/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.avif 920w", "/de/static/9c4b20ab8f0730e587db414ecd8cd355/24329/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.avif 1111w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/9c4b20ab8f0730e587db414ecd8cd355/a0b58/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.webp 230w", "/de/static/9c4b20ab8f0730e587db414ecd8cd355/bc10c/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.webp 460w", "/de/static/9c4b20ab8f0730e587db414ecd8cd355/966d8/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.webp 920w", "/de/static/9c4b20ab8f0730e587db414ecd8cd355/e4604/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.webp 1111w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/9c4b20ab8f0730e587db414ecd8cd355/81c8e/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.png 230w", "/de/static/9c4b20ab8f0730e587db414ecd8cd355/08a84/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.png 460w", "/de/static/9c4b20ab8f0730e587db414ecd8cd355/c0255/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.png 920w", "/de/static/9c4b20ab8f0730e587db414ecd8cd355/ae77d/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.png 1111w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/9c4b20ab8f0730e587db414ecd8cd355/c0255/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_02.png",
              "alt": "Web User Interface - 1440p Series - Network IP Configuration",
              "title": "Web User Interface - 1440p Series - Network IP Configuration",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/96a7e7575c77f09ac288b86d8605b15f/2bef9/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "31.73913043478261%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA6ElEQVQY021RSY7DMAzLJ6ZNvEq2vCT5//s4kNwAPfQgkBBoimE2lg5qE4EFykNKeO0H3oezefjri79/cRewR8a2hwzqF3jc2H1CqRVVGqgUHN6jisCFiExs/HAemQukdRAXM/s231R0XSfOc2LMiTaGYR8D0ruh7gx7t3l2j06HSzXjTa/1MVFEbGLOliikjEQEHyNiJnCtttOkmkx5qfLRJNO4kLClTJZkGbAlUCytoo21V/E8T3vc+kqn7677/lQTEIsgUl2G2pt2sztvP0UvBo6Lh2if8vdeXanmQT2mqN2HduOIhH/QlKPO7b0d/gAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/96a7e7575c77f09ac288b86d8605b15f/e4706/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.avif 230w", "/de/static/96a7e7575c77f09ac288b86d8605b15f/d1af7/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.avif 460w", "/de/static/96a7e7575c77f09ac288b86d8605b15f/7f308/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.avif 920w", "/de/static/96a7e7575c77f09ac288b86d8605b15f/e3723/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.avif 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/96a7e7575c77f09ac288b86d8605b15f/a0b58/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.webp 230w", "/de/static/96a7e7575c77f09ac288b86d8605b15f/bc10c/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.webp 460w", "/de/static/96a7e7575c77f09ac288b86d8605b15f/966d8/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.webp 920w", "/de/static/96a7e7575c77f09ac288b86d8605b15f/a9a89/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.webp 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/96a7e7575c77f09ac288b86d8605b15f/81c8e/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.png 230w", "/de/static/96a7e7575c77f09ac288b86d8605b15f/08a84/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.png 460w", "/de/static/96a7e7575c77f09ac288b86d8605b15f/c0255/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.png 920w", "/de/static/96a7e7575c77f09ac288b86d8605b15f/2bef9/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.png 1024w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/96a7e7575c77f09ac288b86d8605b15f/c0255/1440p_WebUI_Network_IP_Configuration_IPv6_AVM_03.png",
              "alt": "Web User Interface - 1440p Series - Network IP Configuration",
              "title": "Web User Interface - 1440p Series - Network IP Configuration",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Bei IPv6 im, Gegensatz zu IPv4, werden Ports nur geöffnet nicht weitergeleitet, so dass jede Instar 2K Kamera im Netzwerk über `}<strong parentName="p">{`denselben Port laufen kann`}</strong>{`, man aber für jede Kamera eine eigene DDNS Adresse verwenden muss.`}</p>
    <p>{`Zum Vergleich, bei einer IPv4 Portweiterleitung wird jeder Kamera ein eindeutiger Port durchgeleitet. Man kann danach `}<strong parentName="p">{`über eine DDNS Adresse`}</strong>{` auf alle Kameras im gleichen Netzwerk zugreifen, indem man einfach andere Ports an die Adresse anhängt.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/24ef403e911d639a0bad1edd74b9180f/d9199/1440p_WebUI_Network_IP_Configuration_Ports.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.60869565217391%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACJUlEQVQoz2WSWU/bQBRG+RVFFRB4AydOqJDIZsdbVoKX2GMbOxSp4gWpL7SiKkup1P9QVVVfWtEEof7KU3kgBZWHo290x3M0946XVLVKWdmittPA//ib/fM/jD7cMjyby+y9n2O/m+FI5tinM1nzLu7IrucYlsPy8gtWVlfY2NhgqVKpoGxtUtupk13+JLu+5eDTjPx6LkmvZiRXM+LLGeLihliub3j95Y7p+Q/amsnWpoJaqVEuqyyVy2UKVLWCt9djsj+QRN6QYNyXa+GNCN0B02TC8VHGYRrKujvqY3QcTKOHbfVpNrRHYbVaJYwEWTZFxAlCJPcZJ0QiliTpgfxmb7wvCYKQntPHNGwpru+27lv+JwxD8jwnTVOSJJFZEMex3CsIgoDRaEQURQgR4rsOjm1jGl3q9SdCVVXlgSzPybJMChcspIUkCCaMx2OiSJCmIXlqY5mWFDYaraczVAmjSMqEEM8oZAW+79PrdhkMhojIJ3RNLMOi79i0mg9CRVGksDgwnU5lLlp8SlH3PA/TNGk0W+RiwmEwwDI6UtioN5+3vJjh/7LJZCLTdV1s26LZbnMUCz6/ieh3bbpO7/GVixsWj1K0tniI+/mlJLEgmR5zcPYdcfGLt4enfOsO+dp3OfF8/G6T3Z1ttmuvqFTUhx9bUeQtO50OpmGi6zqapqFpD6l30K0Buj3E1C2G7TYjTaddb/BydY21tRKlUon19XX+Akqam1WFELRZAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/24ef403e911d639a0bad1edd74b9180f/e4706/1440p_WebUI_Network_IP_Configuration_Ports.avif 230w", "/de/static/24ef403e911d639a0bad1edd74b9180f/d1af7/1440p_WebUI_Network_IP_Configuration_Ports.avif 460w", "/de/static/24ef403e911d639a0bad1edd74b9180f/7f308/1440p_WebUI_Network_IP_Configuration_Ports.avif 920w", "/de/static/24ef403e911d639a0bad1edd74b9180f/542bc/1440p_WebUI_Network_IP_Configuration_Ports.avif 960w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/24ef403e911d639a0bad1edd74b9180f/a0b58/1440p_WebUI_Network_IP_Configuration_Ports.webp 230w", "/de/static/24ef403e911d639a0bad1edd74b9180f/bc10c/1440p_WebUI_Network_IP_Configuration_Ports.webp 460w", "/de/static/24ef403e911d639a0bad1edd74b9180f/966d8/1440p_WebUI_Network_IP_Configuration_Ports.webp 920w", "/de/static/24ef403e911d639a0bad1edd74b9180f/e46b2/1440p_WebUI_Network_IP_Configuration_Ports.webp 960w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/24ef403e911d639a0bad1edd74b9180f/81c8e/1440p_WebUI_Network_IP_Configuration_Ports.png 230w", "/de/static/24ef403e911d639a0bad1edd74b9180f/08a84/1440p_WebUI_Network_IP_Configuration_Ports.png 460w", "/de/static/24ef403e911d639a0bad1edd74b9180f/c0255/1440p_WebUI_Network_IP_Configuration_Ports.png 920w", "/de/static/24ef403e911d639a0bad1edd74b9180f/d9199/1440p_WebUI_Network_IP_Configuration_Ports.png 960w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/24ef403e911d639a0bad1edd74b9180f/c0255/1440p_WebUI_Network_IP_Configuration_Ports.png",
              "alt": "Web User Interface - 1440p Series - Network IP Configuration",
              "title": "Web User Interface - 1440p Series - Network IP Configuration",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "webzugriff-verschlüsselung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#webzugriff-verschl%C3%BCsselung",
        "aria-label": "webzugriff verschlüsselung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Webzugriff Verschlüsselung`}</h3>
    <p>{`Verwenden Sie den HTTPS-Port, den Sie oben festgelegt haben, um sicher auf die Webbenutzeroberfläche Ihrer Kamera zuzugreifen. Fügen Sie diesen Port der `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/Fernzugriff/"
      }}>{`DDNS-Adresse`}</a>{` Ihrer Kamera hinzu und stellen Sie das `}<em parentName="p">{`https://`}</em>{` Präfix vor, wenn Sie mit Ihrem Webbrowser auf die Weboberfläche zugreifen möchten - z.B. Wenn Ihre Kamera die DDNS-Adresse abcd12.ddns-instar.de hat und Ihr HTTPS-Port 443 ist, geben Sie `}<strong parentName="p"><a parentName="strong" {...{
          "href": "https://abcd12.ddns-instar.de:443"
        }}>{`https://abcd12.ddns-instar.de:443`}</a></strong>{` in die Adresszeile Ihres Browsers ein.`}</p>
    <p>{`Beachten Sie, dass INSTAR Deutschland ein gültiges Verschlüsselungszertifikat für Ihre DDNS-Adresse bereitgestellt hat. Wenn Sie versuchen, über HTTPS auf die lokale IP-Adresse Ihrer Kamera zuzugreifen - z.B. `}<strong parentName="p"><a parentName="strong" {...{
          "href": "https://192.168.1.20:443"
        }}>{`https://192.168.1.20:443`}</a></strong>{`, werden Sie mit einer Sicherheitswarnung konfrontiert. Sie können dort aber bedenkenlos eine Ausnahme für die lokale IP der Kamera hinzufügen. Anschließend werden Sie auch beim lokalen Zugriff die Verschlüsselung nutzen können:`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <CertCards mdxType="CertCards" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      